

import {
    ActionPointInfo,
    IActionPointInfo,
    IMiddleware,
    Middleware,
} from '@tencent/workbench';
import { SLIDE_ADAPTER } from '../editor-adpater/slide-adapter';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';

export const IAutoReportMiddleware = Symbol.for('IAutoReportMiddleware');

const triggerToActionMap = {
    onClick: 'click',
    onShow: 'show',
};

/**
 * workbench 自动拦截上报中间件
 */
@Middleware({
    adapters: [SLIDE_ADAPTER],
})
export class AutoReportMiddleware implements IMiddleware {
    public constructor() {}

    /**
     * 主要处理 onShow 与 onClick，用于曝光与点击上报
     */
    public use(@ActionPointInfo() info: IActionPointInfo) {
        this.generateReportInfo(info);
    }

    /**
     * 生成自动上报信息并上报
     * 上报事件：[operaname=doc_editor]_[module]_[action]
     *   - module 规则：detailPage_[元素位置]，比如 mobile_tab_menu，mobile-more-menu, toolbar, float_toolbar 等
     *   - action 规则：onShow 曝光；onClick 点击
     * ver5: 点击的按钮名字
     * ver6: 按钮位置来源，通常是 workbench 的 ui path，取第 0 个即可
     * ver7: 渠道类型，cac 的 domain_client
     */
    private generateReportInfo(info: IActionPointInfo) {
        tdw({
            opername: 'doc_editor',
            module: `detailPage_${info.from}`,
            action: triggerToActionMap[info.trigger] || 'none',
            ver5: info.name,
            ver6: info.path[0],
            ver7: appConfigInstance.getConfig('domain'),
        });
    }
}
